import React, { useState } from 'react';
import styles from '../../styles/BuildingPreviews/BuildingOverview.module.css';
import Lightbox from 'yet-another-react-lightbox';
import "yet-another-react-lightbox/styles.css";
import { Captions, Thumbnails } from "yet-another-react-lightbox/plugins";
import "yet-another-react-lightbox/plugins/captions.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";

const BuildingOverview = ({ building }) => {
  const [isGalleryOpen, setIsGalleryOpen] = useState(false);

  const fullBuilding = {
    rating: building.rating ?? 4.7,
    reviewCount: building.reviewCount ?? 28,
    startingPrice: building.startingPrice ?? 2500,
    unitsAvailable: building.unitsAvailable ?? 5,
    ImageGallery: building.ImageGallery ?? [],
    ...building,
  };

  const slides = fullBuilding.ImageGallery.map((src) => ({ src }));


  return (
    <div className={styles.overviewContainer}>
      <div className={styles.overviewMainLayout}>
        <div className={styles.imageContainer}>
          <img
            src={fullBuilding.ImageGallery[0]}
            alt={`View of ${fullBuilding.Address}`}
            className={styles.heroImage}
          />
          <button className={styles.viewMoreBtn} onClick={() => setIsGalleryOpen(true)}>
            📸 View Gallery ({slides.length} Photos)
          </button>
        </div>

        <div className={styles.infoContainer}>
          <div className={styles.propertyOverview}>
            <h3 className={styles.sectionTitle}>🏠 Property Overview</h3>
            <p><strong>📌 Building Type:</strong> {fullBuilding.BuildingType}</p>
            <p><strong>🏢 Total Units:</strong> {fullBuilding.TotalUnits}</p>
            <p><strong>🌟 Most Loved Feature:</strong> {fullBuilding.MostLovedFeature}</p>
          </div>

          <hr className={styles.sectionDivider} />

          <div className={styles.propertyDescription}>
            <h3 className={styles.sectionTitle}>📜 Description</h3>
            <p>{fullBuilding.Description}</p>
          </div>

          <hr className={styles.sectionDivider} />

          <div className={styles.amenitiesSection}>
            <h3 className={styles.sectionTitle}>✅ Amenities</h3>
            <div className={styles.amenitiesGrid}>
              {fullBuilding.Amenities?.map((amenity, index) => (
                <div key={index} className={styles.amenityItem}>
                  {amenity}
                </div>
              ))}
            </div>
          </div>
		  
		<Lightbox
          open={isGalleryOpen}
          close={() => setIsGalleryOpen(false)}
          slides={slides}
          plugins={[Captions, Thumbnails]}
        />

          <button className={styles.scheduleTourBtn}>📅 Schedule Tour</button>
        </div>
      </div>
    </div>
  );
};

export default BuildingOverview;
